import { gql } from "@apollo/client";
import { DocumentNode } from "graphql";

export const USER_FRAGMENT: DocumentNode = gql`
  fragment UserFragment on User {
    id
    accountEmail
    profileEmail
    firstName
    lastName
    username
    indeedShareStatus
    oAuthProviders
    # CDPE-774: oAuthProviders is names only. The account page has to name the
    # actual sign-in method and its address, so it can say plainly that the
    # email above is not one.
    oAuthIdentities {
      provider
      email
    }
    connectedWithIndeed
  }
`;
